export default {
	points: {
		1920: ['Full HD'],
		1792: ['MacBook Pro (16")'],
		1680: ['MacBook Pro (15")'],
		1500: ['Surface Book (Landscape)'],
		1440: ['MacBook Pro/Air (13")'],
		1400: ['MacBook Pro (earlier 15" models)'],
		1366: ['MacBook Air (11")', 'iPad Pro landscape'],
		1280: ['Retina MacBook (12")', 'MacBook Pro (earlier 13" models)'],
		1024: ['iPad Pro (12.9")', 'Galaxy Tab S3'],
		912: ['Surface Pro 2017 (Portrait)'],
		834: ['iPad Pro (10.5")'],
		800: ['Galaxy Tab (10")', 'Galaxy Tab (8.9")'],
		768: ['iPad Pro (9.7")', 'iPad Air/Air 2'],
		479: ['LG G5/G6', 'One Plus 3', 'Galaxy Note 5'],
		428: ['iPhone 12 Pro Max'],
		414: ['iPhone 11/XR/XS Max/11 Pro Max'],
		390: ['iPhone 12/12 Pro'],
		375: ['iPhone X/11 Pro/8/7/6/SE'],
		360: ['Samsung S6/S7/S8/S9/Note', 'iPhone 12 Mini', 'Huawei P10/P20', 'Google Pixel'],
		320: ['iPhone 5', 'iPhone SE 1st gen', 'Blackberry'],
	},
};
